var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiltroBarra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00016 0.333344C3.3135 0.333344 0.333496 3.31334 0.333496 7.00001C0.333496 10.6867 3.3135 13.6667 7.00016 13.6667C10.6868 13.6667 13.6668 10.6867 13.6668 7.00001C13.6668 3.31334 10.6868 0.333344 7.00016 0.333344ZM10.3335 9.39334L9.3935 10.3333L7.00016 7.94001L4.60683 10.3333L3.66683 9.39334L6.06016 7.00001L3.66683 4.60668L4.60683 3.66668L7.00016 6.06001L9.3935 3.66668L10.3335 4.60668L7.94016 7.00001L10.3335 9.39334Z",
    fill: "rgba(9, 9, 9, 9.99)",
    fillOpacity: 0.26
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltroBarra);
export default __webpack_public_path__ + "static/media/filtro_barra.e85e386591a0ac3cad00f3067959e703.svg";
export { ForwardRef as ReactComponent };